import React from "react"

import {Card} from "@irati/ui/src/Layout"
import {H2, Body} from "@irati/ui/src/Typography"


const MerchandiseError = () => (
  <Card marginTop={2}>
    <H2 marginBottom={2}>Error: Cannot browse this page!</H2>
    <Body>You! Cheeky beaver...<br />Nothing to see here!</Body>
  </Card>
)

export default MerchandiseError
